import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import Testimonial from '@segment/templates/Testimonial'

const SingleTestimonial = () => {
  return (
    <SectionBase variant="noCopy">
      <Section.Contents>
        <TestimonialWrapper>
          <Testimonial company="box" />
        </TestimonialWrapper>
      </Section.Contents>
    </SectionBase>
  )
}

const TestimonialWrapper = styled.div`
  max-width: 900px;
  margin: 0 auto;
`

export default SingleTestimonial
